import React from 'react';
import { logInfo } from '../../../../utils/logger';
import { RouteLayer } from './layers/RouteLayer';
import { POILayer } from './layers/POILayer';

export const POIManager = ({ map, pois = [], routes = [], visibilityState = {}, onDriveTo, onDelete, settings }) => {
  console.log('[POIManager] Rendering with:', { 
    poisCount: pois?.length, 
    routesCount: routes?.length,
    hasMap: !!map,
    visibilityState,
    settings
  });

  if (!map) {
    return null;
  }

  logInfo('Rendering POI Manager with layers');

  return (
    <>
      <RouteLayer 
        routes={routes}
        visibilityState={visibilityState}
        map={map}
        settings={settings}
      />
      <POILayer
        pois={pois}
        visibilityState={visibilityState}
        map={map}
        onDriveTo={onDriveTo}
        onDelete={onDelete}
        settings={settings}
      />
    </>
  );
};

export default POIManager;